import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { Map, List } from 'immutable';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from '../store/connect';
import { fontFamilyHeading } from '../styles/helpers/mixins';
import MainProductImage from './MainProductImage';
import { ProductImage } from '../styles/ProductImage';
import { color, breakpoint } from '../styles/helpers/variables';
import { SITE_ROOT_URL } from '../constants/endpoints';
import { LoadingSpinner } from '../styles/LoadingSpinner';
import { getQuickSearchProductsByList } from '../selectors/reselectCategory';
import { removeQuickSearch } from '../actions/actionCreators';
import { MATERIAL_IMAGE } from '../constants/imageTypes';

class SearchResults extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollPosition: 0,
      currentPath: undefined
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.viewstate.get('globalSearchActive') !== prevProps.viewstate.get('globalSearchActive')) {
      if (this.props.viewstate.get('globalSearchActive') && window.innerWidth < breakpoint.large) {
        this.enableBodyScrollLock();
      } else if (document.body.style.position === 'fixed') {
        this.disableBodyScrollLock();
      }
    }
  }

  getSearchResultProducts() {
    const { products } = this.props;
    return products
      .sortBy(item => item.get('relevance'))
      .reverse()
      .take(5)
      .map(item => {
        if (!item.get('url')) {
          return false;
        }
        const mainImageType = item
          .get('variants')
          .find(variant => variant.get('id') === item.get('defaultVariantId'))
          .getIn(['mainImage', 'type']);
        let imageUrl = item.getIn(['mainImage', 'url']);
        if (mainImageType === MATERIAL_IMAGE && !item.get('allVariantsHaveSameRelevance')) {
          imageUrl = item
            .get('variants')
            .find(variant => variant.get('id') === item.get('defaultVariantId'))
            .getIn(['mainImage', 'url']);
        }
        return (
          <ProductContainer key={item.get('id')} to={item.get('url')} onClick={() => this.props.removeQuickSearch()}>
            <div>
              <MainProductImage small>
                <ProductImage src={SITE_ROOT_URL + imageUrl} />
              </MainProductImage>
            </div>
            <ProductTitle>{item.get('name')}</ProductTitle>
          </ProductContainer>
        );
      })
      .toArray();
  }

  getSearchResultPage(pageType) {
    const { globalQuickResults } = this.props;
    return globalQuickResults
      .getIn([pageType, 'hits'], Map())
      .sortBy(item => item.get('relevance'))
      .reverse()
      .take(5)
      .map(item => {
        const itemData = item.get('item', Map());
        if (!itemData.get('url')) {
          return false;
        }
        return (
          <PageLink key={itemData.get('id')} to={itemData.get('url')} onClick={() => this.props.removeQuickSearch()}>
            {pageType === 'pages' ? itemData.getIn(['fields', 'title']) : itemData.getIn(['name'])}
          </PageLink>
        );
      })
      .toArray();
  }

  getTotalSearchResultHits() {
    const { globalQuickResults } = this.props;
    let totalHits = 0;

    globalQuickResults.forEach(type => {
      totalHits += type ? type.get('hits', List()).size : 0;
    });

    return totalHits;
  }

  enableBodyScrollLock() {
    const scrollPosition = window.pageYOffset;
    this.setState({
      scrollPosition,
      currentPath: this.props.location.pathname
    });
    document.body.style.position = 'fixed';
    document.body.style.left = 0;
    document.body.style.right = 0;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.overflowY = 'scroll';
  }

  disableBodyScrollLock() {
    document.body.removeAttribute('style');
    if (this.state.currentPath === this.props.location.pathname) {
      window.scrollTo(0, this.state.scrollPosition);
    }
  }

  renderPageResult(title, type) {
    const { globalQuickResults } = this.props;
    const pages = this.getSearchResultPage(type);

    if (!globalQuickResults.getIn([type, 'hits'], Map()).size) {
      return false;
    }

    // if (!globalQuickResults.getIn([type, 'totalHits'], Map())) {
    //   return false;
    // }

    // if (pages.length === 0) return false;

    return (
      <CenterText>
        <PageCategoryTitle>{title}</PageCategoryTitle>
        {pages}
      </CenterText>
    );
  }

  render() {
    const { globalQuickQuery, globalQuickStatus, viewstate } = this.props;

    if (!viewstate.get('globalSearchActive')) {
      return null;
    }

    const products = this.getSearchResultProducts();
    const categories = this.renderPageResult('Kategorier', 'categories');
    const pages = this.renderPageResult('Sidor', 'pages');
    const totalHits = this.getTotalSearchResultHits();

    return (
      <SearchResultsSearchResults loading={globalQuickStatus !== 'SUCCESS'}>
        <SearchResultProducts>{products.length ? products : 'Inga matchande produkter'}</SearchResultProducts>
        {(categories || pages) && (
          <SearchResultLinks>
            {categories}
            {pages}
          </SearchResultLinks>
        )}
        <ShowAllResultsButton to={`/sok/${window.encodeURIComponent(globalQuickQuery)}`}>
          Visa alla {totalHits} träffar
        </ShowAllResultsButton>
        {globalQuickStatus !== 'SUCCESS' && <LoadingSpinner />}
      </SearchResultsSearchResults>
    );
  }
}

const SearchResultsSearchResults = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  max-height: calc(100vh - 25px - 100%);
  width: 100%;
  background-color: ${color.white};
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 1;
  @media screen and (min-width: ${breakpoint.large}px) {
    top: calc(100% - 20px);
    left: 50%;
    max-height: calc(100vh - 35px - 100% + 20px - 20px);
    width: calc(((100% - (80px * 2)) / 2) - (20px * 2));
    border: 1px solid ${color.grey};
    ${props =>
      props.loading &&
      css`
        border-color: ${color.darkerGrey};
      `};
    transform: translateX(-50%);
  }
  @media screen and (min-width: ${breakpoint.extraLarge}px) {
    width: calc((100% - (80px * 2)) / 2);
  }
  @media screen and (min-width: 1580px) {
    width: ${(1580 - 80 * 2) / 2}px;
  }
`;

const SearchResultProducts = styled.div`
  padding: 20px;
  background-color: ${color.lightGrey};
  color: ${color.darkerGrey};
  font-size: 14px;
  text-align: center;
`;

const ProductContainer = styled(Link)`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  text-decoration: none;

  &:last-child {
    margin-bottom: 0;
  }

  div:first-child {
    width: 70px;
    margin-right: 20px;
    margin-bottom: 0;
  }

  p {
    flex: 1;
  }
`;

const ProductTitle = styled.p`
  ${fontFamilyHeading};
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.8;
  letter-spacing: normal;
  text-align: left;
  color: #000000 !important;
  text-decoration: none !important;
  margin: 0;
`;

const SearchResultLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 0 15px;
`;

const CenterText = styled.div`
  margin: 15px 30px 15px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
`;

const PageCategoryTitle = styled.p`
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.8px;
  text-align: left;
  color: #000000;
  text-transform: uppercase;
  padding: 5px;
  margin: 0;
`;

const PageLink = styled(Link)`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.79;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  text-decoration: none;
  display: inline-block;
  margin: 0;
  padding: 4px;
`;

const ShowAllResultsButton = styled(Link)`
  display: block;
  padding: 12.5px 20px;
  background-color: ${color.black};
  color: ${color.white};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 0.125em;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  /* @media screen and (min-width: ${breakpoint.large}px) {
    margin: 0 -1px -1px -1px;
  } */
`;

SearchResults.defaultProps = {
  globalQuickResults: Map(),
  globalQuickQuery: null,
  globalQuickStatus: null,
  viewstate: Map(),
  products: Map()
};

SearchResults.propTypes = {
  globalQuickResults: PropTypes.instanceOf(Map),
  globalQuickQuery: PropTypes.string,
  globalQuickStatus: PropTypes.string,
  removeQuickSearch: PropTypes.func.isRequired,
  viewstate: PropTypes.instanceOf(Map),
  products: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired
};

export default connect(SearchResults, { removeQuickSearch }, store => ({
  globalQuickResults: store.quickSearch.results,
  globalQuickQuery: store.quickSearch.query,
  globalQuickStatus: store.quickSearch.status,
  viewstate: store.viewstate,
  products: getQuickSearchProductsByList(store)
}));



// WEBPACK FOOTER //
// ./src/components/SearchResults.js